import React from "react";
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "../../basic/table.tsx";

export interface ColumnDef<T> {
    key: keyof T;
    header: string;
    cell?: (item: T) => React.ReactNode;
    className?: string;
}

interface DataTableProps<T> {
    data: T[];
    columns: ColumnDef<T>[];
    onRowClick?: (item: T) => void;
    className?: string;
    emptyState?: React.ReactNode;
    withBorder?: boolean;
}

export function DataTable<T extends { id: number | string }>({
                                                                 data,
                                                                 columns,
                                                                 onRowClick,
                                                                 className = "",
                                                                 emptyState,
                                                                 withBorder = false
                                                             }: DataTableProps<T>) {
    if (data.length === 0 && emptyState) {
        return <div className={className}>{emptyState}</div>;
    }

    return (
        <div className={`${withBorder ? "border rounded-lg " : ""}${className}`}>
            <Table>
                <TableHeader>
                    <TableRow>
                        {columns.map((column) => (
                            <TableHead key={String(column.key)} className={column.className}>
                                {column.header}
                            </TableHead>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.map((item) => (
                        <TableRow
                            key={item.id}
                            className={onRowClick ? "cursor-pointer hover:bg-muted/50" : ""}
                            onClick={() => onRowClick?.(item)}
                        >
                            {columns.map((column) => (
                                <TableCell key={String(column.key)} className={column.className}>
                                    {column.cell ? column.cell(item) : String(item[column.key] ?? "")}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}